import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import appConfig from 'app-config';

const isGpa = appConfig.portalCode === 'GPA';

export default {
    createUnderlyingPolicy: (request, additionalHeaders = {}) => {
        const methodName = request.sessionUUID ? 'createUnderlyingPolicyInNewBusiness' : 'createUnderlyingPolicyInEndorsement';
        const requestDTO = {
            quoteID: request.quoteID,
            policyType: request.policyType,
            sessionUUID: request.sessionUUID
        };
        const url = getProxiedServiceUrl(isGpa ? 'gatewayquote/underlyingpolicy' : 'underlyingpolicy');
        return JsonRPCService.send(url, methodName, [requestDTO], additionalHeaders);
    },
    removeUnderlyingPolicy: (request, additionalHeaders = {}) => {
        const methodName = request.sessionUUID ? 'removeUnderlyingPolicyInNewBusiness' : 'removeUnderlyingPolicyInEndorsement';
        const requestDTO = {
            quoteID: request.quoteID,
            policyType: request.policyType,
            underlyingPolicy: request.underlyingPolicy,
            sessionUUID: request.sessionUUID
        };
        const url = getProxiedServiceUrl(isGpa ? 'gatewayquote/underlyingpolicy' : 'underlyingpolicy');
        return JsonRPCService.send(url, methodName, [requestDTO], additionalHeaders);
    }
};
